import service from './index'

const prefix = '/common-uam';

export const fetchGetTenantInfoList = (userId: string) => service.get(`${prefix}/user-tenant-relations/tenant-info-list?user-id=${userId}`);

export const getRelatedMenuResourceList = (body: any) => service.post(prefix + '/resources/menu/related-resource', body);

// Current user's regional settings: { language, timeZone, dateFormat, timeFormat }
export const getUserSettings = () => service.get(`${prefix}/session/user-settings`);

// Tenant regional settings used as parse (cur*) options for CDC-formatted datetimes
export const fetchTenantSettings = () =>
  service.get(`${prefix}/system-settings/tenant-settings`);
